export interface GalleryImage {
  id: number;
  title: string;
  alt: string;
  url: string;
}

export const galleryImages: GalleryImage[] = [
  {
    id: 1,
    title: "Persian Heritage",
    alt: "Traditional Persian art and culture",
    url: "https://public.youware.com/image/86e26126-3337-4155-8693-93e5417ae25d/1pd23t7g7c.png",
  },
  {
    id: 2,
    title: "Traditional Preparation",
    alt: "Traditional food preparation methods",
    url: "https://public.youware.com/image/41863841-595e-4b8d-a426-f573d252eab5/acq0npblzt.png",
  },
  {
    id: 3,
    title: "Rose Water Essence",
    alt: "Beautiful rose water and fragrant ingredients",
    url: "https://public.youware.com/image/7bc28543-d370-4617-b61a-ace45ee47916/6sef5isizj.png",
  },
  {
    id: 4,
    title: "Family Moments",
    alt: "Traditional family gathering and sharing food",
    url: "https://public.youware.com/image/1609ce41-b331-4407-927b-e942ccb1760f/ifce46vwjt.png",
  },
  {
    id: 5,
    title: "Cultural Tradition",
    alt: "Persian culture and tradition celebration",
    url: "https://public.youware.com/image/923abe73-e734-4e84-8460-1536e8fa8e39/pcd5qc4sbq.png",
  },
];
